var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('rooms',{staticClass:"rooms",attrs:{"key-prefix":_vm.controllerId,"rooms":_vm.rooms,"controller-name":_vm.controllerName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }